module.exports = __webpack_public_path__ + "assets/img/logo-frame.654455c1.png";